module.exports = __webpack_public_path__ + "img/gszz1@2x.62a9ea05.png";